import * as t from './actionTypes';

let initialState = { loggedIn: false, user: {email: '...', password: 'XXXT'} };

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case t.LOGIN_SUCCESS:
      var user = action.user.user;
      var refreshToken = user.refreshToken;
      localStorage.setItem('refreshToken', refreshToken);
      localStorage.setItem('user', JSON.stringify(user));

      state = Object.assign({}, state, {loggedIn: true, user: user });

      return state;

    case t.LOGGED_OUT:
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('user');
      state = Object.assign({}, state, {loggedIn: false, user: null });

      return state;

    default:
      return state;
  }
};

export default authReducer;
